<template>
  <roe-plan-design-edit-form
    :designs="designs"
    name="Employer Match"
    :labels="['Eligibility', 'Amount', 'Other', 'Misc', 'Vesting']"
    :view-input="employerMatch"
    :form="$v.editableDesign"
    :tooltipData="employerMatchTooltip"
    :formIsInvalid="$v.editableDesign.$invalid"
  >
    <div class="right-panel-form-row-wrap">
      <div class="right-panel-label-wrap">
        <div class="light-label">
          Do you have an Employer Matching Contribution?
        </div>
      </div>
      <div class="right-panel-form-row">
        <div class="form-unit">
          <roe-employer-match-select :design="$v.editableDesign">
          </roe-employer-match-select>
        </div>
      </div>
      <template v-if="showForm(editableDesign)">
        <div class="right-panel-label-wrap">
          <div class="light-label">
            Does the plan have an age requirement for Employer Matching
            Contributions?
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-age-requirement-select
              :design="$v.editableDesign"
            >
            </roe-employer-match-age-requirement-select>
          </div>
        </div>
        <template v-if="showAgeRequirement(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">Age Requirement (AR)</div>
          </div>
          <div class="right-panel-form-row">
            <div class="form-unit">
              <roe-employer-match-age-requirement-years-input
                :design="$v.editableDesign"
              >
              </roe-employer-match-age-requirement-years-input>
            </div>
            <div class="form-unit">
              <roe-employer-match-age-requirement-months-input
                :design="$v.editableDesign"
              >
              </roe-employer-match-age-requirement-months-input>
            </div>
          </div>
        </template>
        <div class="right-panel-label-wrap">
          <div class="light-label">
            Does the plan have a service requirement for Employer Matching
            Contributions?
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-service-requirement-select
              :design="$v.editableDesign"
            >
            </roe-employer-match-service-requirement-select>
          </div>
        </div>
        <template v-if="showServiceRequirement(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">Service Requirement (SR)</div>
          </div>
          <div class="right-panel-form-row">
            <div class="form-unit">
              <roe-employer-match-service-requirement-months-input
                :design="$v.editableDesign"
              >
              </roe-employer-match-service-requirement-months-input>
            </div>
          </div>
        </template>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Is the Employer Matching Contribution fixed each year or can it vary
            from year to year?
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-type-select :design="$v.editableDesign">
            </roe-employer-match-type-select>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">Type of Employer Matching Contribution</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-contribution-type-select
              :design="$v.editableDesign"
            ></roe-employer-match-contribution-type-select>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">Funding Frequency</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-funding-frequency-select
              :design="$v.editableDesign"
            ></roe-employer-match-funding-frequency-select>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">Post Tax Contributions</div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-post-tax-contributions-radio
              :design="$v.editableDesign"
            ></roe-employer-match-post-tax-contributions-radio>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Does the Employer Matching Contribution vary from Year to Year?
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-contrib-based-yos-radio
              :design="$v.editableDesign"
            ></roe-employer-match-contrib-based-yos-radio>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Does the Employer Matching Contribution vary based on EE Years of
            Service?
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-yos-vary-ee-radio
              :design="$v.editableDesign"
            ></roe-employer-match-yos-vary-ee-radio>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Number of Tiers in Employer Match
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-match-number-tiers-select
              :design="$v.editableDesign"
            ></roe-employer-match-number-tiers-select>
          </div>
        </div>
        <template v-for="(tier, index) in $v.editableDesign.tiers.$each.$iter">
          <div class="right-panel-label-wrap">
            <div class="main-label">{{ tierLabel(+index) }}</div>
          </div>
          <div class="right-panel-label-wrap">
            <div class="light-label">Matching Amount</div>
            <div
              class="light-label"
              v-if="showTierDeferralRate(editableDesign)"
            >
              Compensation
            </div>
            <div
              class="light-label"
              v-if="showTierContributionAmount(editableDesign)"
            >
              Contributions
            </div>
          </div>
          <div class="right-panel-form-row">
            <div class="form-unit">
              <roe-tier-matching-amount-input :tier="tier">
              </roe-tier-matching-amount-input>
            </div>
            <div class="form-unit">
              <roe-tier-deferral-rate-input
                :tier="tier"
                :is-deferral-rate="showTierDeferralRate(editableDesign)"
              ></roe-tier-deferral-rate-input>
              <roe-tier-contribution-amount-input
                :tier="tier"
                :is-contribution-amount="
                  showTierContributionAmount(editableDesign)
                "
              ></roe-tier-contribution-amount-input>
            </div>
          </div>

          <template v-if="showTierYosUpperLimit(editableDesign)">
            <div class="right-panel-label-wrap">
              <div class="light-label">
                Years of Service
              </div>
            </div>
            <div class="right-panel-form-row">
              <roe-tier-yos-upper-limit-input
                :tier="tier"
                :tiers="editableDesign.tiers"
                :index="+index"
              >
              </roe-tier-yos-upper-limit-input>
            </div>
          </template>
          <template v-if="showTierApplicableYear(editableDesign)">
            <div class="right-panel-label-wrap">
              <div class="light-label">
                Applicable Year
              </div>
            </div>
            <div class="right-panel-form-row">
              <roe-tier-applicable-year-input
                :tier="tier"
                :value="new Date().getFullYear() + +index"
              ></roe-tier-applicable-year-input>
            </div>
          </template>
        </template>

        <template v-if="showDollarLimit(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">
              Is there a dollar limit for Employer Matching Contributions?
            </div>
          </div>
          <div class="right-panel-form-row">
            <roe-employer-match-dollar-limit-radio
              :design="$v.editableDesign"
            ></roe-employer-match-dollar-limit-radio>
          </div>
        </template>
        <template v-if="showDollarLimitAmount(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">
              Indicate the Maximum Employer Matching Contribution an employee
              can receive
            </div>
          </div>
          <div class="right-panel-form-row">
            <roe-employer-match-dollar-amount-input
              :design="$v.editableDesign"
            ></roe-employer-match-dollar-amount-input>
          </div>
        </template>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Hire Date For Employer Match
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-hire-date-input
            :design="$v.editableDesign"
          ></roe-employer-match-hire-date-input>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Catch-Up Contributions Matched
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-catch-up-radio
            :design="$v.editableDesign"
          ></roe-employer-match-catch-up-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            True-Up Performed
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-true-up-calculate-radio
            :design="$v.editableDesign"
          ></roe-employer-match-true-up-calculate-radio>
        </div>

        <template v-if="showFrequency(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">
              Indicate how often True-Up Calculations are performed
            </div>
          </div>
          <div class="right-panel-form-row">
            <roe-employer-match-true-up-frequency-select
              :design="$v.editableDesign"
            ></roe-employer-match-true-up-frequency-select>
          </div>
        </template>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            End-of-Year (EOY) requirement applies
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-e-o-y-requirement-radio
            :design="$v.editableDesign"
          ></roe-employer-match-e-o-y-requirement-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Plan Year Service Requirement applies
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-service-req-applies-select
            :design="$v.editableDesign"
          ></roe-employer-match-service-req-applies-select>
        </div>

        <template v-if="showHoursOrMonths(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">
              Plan Year Service Requirement
            </div>
          </div>
          <div class="right-panel-form-row">
            <roe-employer-match-service-req-applies-input
              :design="$v.editableDesign"
            ></roe-employer-match-service-req-applies-input>
          </div>
        </template>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Overtime
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-overtime-radio
            :design="$v.editableDesign"
          ></roe-employer-match-overtime-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Bonuses
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-bonuses-radio
            :design="$v.editableDesign"
          ></roe-employer-match-bonuses-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Commissions
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-comissions-radio
            :design="$v.editableDesign"
          ></roe-employer-match-comissions-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Shift Differential
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-match-shift-differential-radio
            :design="$v.editableDesign"
          ></roe-employer-match-shift-differential-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            The Vesting Schedule for Employer Matching Contribution
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-vesting-select
            :design="$v.editableDesign"
            type="match"
          ></roe-vesting-select>
        </div>

        <roe-vesting-percent-right-panel-inputs
          v-if="showVestingImmediateGraded(editableDesign)"
          :vestingYears="[[1, 2, 3], [4, 5, 6]]"
          :design="$v.editableDesign"
          type="match"
        ></roe-vesting-percent-right-panel-inputs>

        <roe-vesting-percent-right-panel-inputs
          v-if="showVestingImmediateCliff(editableDesign)"
          :vestingYears="[[1, 2, 3]]"
          :design="$v.editableDesign"
          type="match"
        ></roe-vesting-percent-right-panel-inputs>
      </template>
    </div>

    <template v-slot:survey>
      <roe-survey-bar
        label="Average"
        :percent="survey.employer_match.average"
        :percent-precision="2"
        :chart="false"
      ></roe-survey-bar>
      <h4 style="margin-bottom: 10px">Employer Match Distribution</h4>
      <roe-survey-bar
        label="None"
        :percent="survey.employer_match.none"
      ></roe-survey-bar>
      <roe-survey-bar
        label="0% - 1%"
        :percent="survey.employer_match.percent0_1"
      ></roe-survey-bar>
      <roe-survey-bar
        label="1% - 2%"
        :percent="survey.employer_match.percent1_2"
      ></roe-survey-bar>
      <roe-survey-bar
        label="2% - 3%"
        :percent="survey.employer_match.percent2_3"
      ></roe-survey-bar>
      <roe-survey-bar
        label="3% - 4%"
        :percent="survey.employer_match.percent3_4"
      ></roe-survey-bar>
      <roe-survey-bar
        label="4% - 5%"
        :percent="survey.employer_match.percent4_5"
      ></roe-survey-bar>
      <roe-survey-bar
        label="5% - 6%"
        :percent="survey.employer_match.percent5_6"
      ></roe-survey-bar>
      <roe-survey-bar
        label="6% - 7%"
        :percent="survey.employer_match.percent6_7"
      ></roe-survey-bar>
      <roe-survey-bar
        label="7% - 8%"
        :percent="survey.employer_match.percent7_8"
      ></roe-survey-bar>
      <roe-survey-bar
        label="8% - 9%"
        :percent="survey.employer_match.percent8_9"
      ></roe-survey-bar>
      <roe-survey-bar
        label="9% - 10%"
        :percent="survey.employer_match.percent9_10"
      ></roe-survey-bar>
      <roe-survey-bar
        label="> 10%"
        :percent="survey.employer_match.percent10plus"
      ></roe-survey-bar>
    </template>
  </roe-plan-design-edit-form>
</template>

<script>
import RoePlanDesignEditForm from "@/components/alternative-designs/_shared/EditForm";
import RoeSurveyBarLight from "@/components/charts/SurveyBarLight";
import RoeSurveyBar from "@/components/charts/SurveyBar";
import { mapGetters } from "vuex";
import EmployerMatchMixin from "@/components/_shared/inputs/design/_mixins/EmployerMatchMixin";
import {
  RoeEmployerMatchSelect,
  RoeEmployerMatchAgeRequirementSelect,
  RoeEmployerMatchAgeRequirementYearsInput,
  RoeEmployerMatchAgeRequirementMonthsInput,
  RoeEmployerMatchServiceRequirementSelect,
  RoeEmployerMatchServiceRequirementMonthsInput,
  RoeEmployerMatchTypeSelect,
  RoeEmployerMatchFundingFrequencySelect,
  RoeEmployerMatchPostTaxContributionsRadio,
  RoeEmployerMatchYosVaryEeRadio,
  RoeEmployerMatchContributionTypeSelect,
  RoeEmployerMatchContribBasedYosRadio,
  RoeEmployerMatchNumberTiersSelect,
  RoeEmployerMatchDollarLimitRadio,
  RoeTierContributionAmountInput,
  RoeTierDeferralRateInput,
  RoeTierMatchingAmountInput,
  RoeTierYosUpperLimitInput,
  RoeTierApplicableYearInput,
  RoeVestingSelect,
  RoeVestingPercentRightPanelInputs,
  RoeEmployerMatchDollarAmountInput,
  RoeEmployerMatchCatchUpRadio,
  RoeEmployerMatchEOYRequirementRadio,
  RoeEmployerMatchServiceReqAppliesInput,
  RoeEmployerMatchServiceReqAppliesSelect,
  RoeEmployerMatchTrueUpCalculateRadio,
  RoeEmployerMatchTrueUpFrequencySelect,
  RoeEmployerMatchBonusesRadio,
  RoeEmployerMatchComissionsRadio,
  RoeEmployerMatchOvertimeRadio,
  RoeEmployerMatchShiftDifferentialRadio,
  RoeEmployerMatchHireDateInput
} from "@/components/_shared/inputs/design/employer-match";

export default {
  name: "RoeEmployerMatch",
  components: {
    RoeEmployerMatchHireDateInput,
    RoeTierApplicableYearInput,
    RoeEmployerMatchYosVaryEeRadio,
    RoeEmployerMatchPostTaxContributionsRadio,
    RoeEmployerMatchSelect,
    RoeEmployerMatchAgeRequirementSelect,
    RoeEmployerMatchAgeRequirementYearsInput,
    RoeEmployerMatchAgeRequirementMonthsInput,
    RoeEmployerMatchServiceRequirementSelect,
    RoeEmployerMatchServiceRequirementMonthsInput,
    RoeEmployerMatchTypeSelect,
    RoeEmployerMatchFundingFrequencySelect,
    RoeEmployerMatchContributionTypeSelect,
    RoeEmployerMatchContribBasedYosRadio,
    RoeEmployerMatchNumberTiersSelect,
    RoeEmployerMatchDollarLimitRadio,
    RoeEmployerMatchDollarAmountInput,
    RoeTierContributionAmountInput,
    RoeTierDeferralRateInput,
    RoeTierMatchingAmountInput,
    RoeTierYosUpperLimitInput,
    RoeEmployerMatchCatchUpRadio,
    RoeEmployerMatchEOYRequirementRadio,
    RoeEmployerMatchServiceReqAppliesInput,
    RoeEmployerMatchServiceReqAppliesSelect,
    RoeEmployerMatchTrueUpCalculateRadio,
    RoeEmployerMatchTrueUpFrequencySelect,
    RoeEmployerMatchBonusesRadio,
    RoeEmployerMatchComissionsRadio,
    RoeEmployerMatchOvertimeRadio,
    RoeEmployerMatchShiftDifferentialRadio,
    RoeVestingSelect,
    RoeVestingPercentRightPanelInputs,
    RoeSurveyBar,
    RoeSurveyBarLight,
    RoePlanDesignEditForm
  },
  props: {
    designs: {
      type: Array,
      required: true
    }
  },
  mixins: [EmployerMatchMixin],
  validations() {
    return {
      editableDesign: this.employerMatchValidations(this.editableDesign)
    };
  },
  computed: {
    ...mapGetters([
      "editableDesign",
      "employerMatch",
      "employerMatchTooltip",
      "survey"
    ])
  },
  methods: {
    tierLabel(index) {
      const currentYear = new Date().getFullYear();
      let label = `Tier ${index + 1}`;
      if (this.showTierApplicableYear(this.editableDesign)) {
        label += ` (${currentYear + index})`;
      }
      return label;
    }
  }
};
</script>
